import React, { useState } from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { InternalUserIcon, HomeIcon, GrowSIcon } from '../components/Icons/Icons';
import EditNavPopup from '../container/dashboard/Popup/EditNavPopup'

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const localData = useSelector((state) => state.localRedux);
  const Role = localData.role
  const edit = useSelector((state) => state.edit.edit);
  // const permission = localData.permissions
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'Home'}`] : [],
  );
  // const [permissionMenu] = useState(permission)
  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };
  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };
  const handleNavigationClick = (url) => {
    if (edit) {
      setConfirmPopup(true)
      setLinkUrl(url)
    }
  };
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;
  // const canCreate = (rolePermissions, actionRoleId) => {
  //   const permissionsArray = rolePermissions.split(",").map(p => p.trim());
  //   return permissionsArray.includes(actionRoleId) || permissionsArray.includes("ALL");
  // };
  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'Home'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >

      {Role === "Super Admin" ?
        <Menu.Item key="home"
          icon={
            <NavLink className="menuItem-iocn" to={!edit ? `${path}` : combinedUrl} onClick={() => edit && handleNavigationClick(`${path}`)}>
              <InternalUserIcon />
            </NavLink>
          }>
          <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}`)} to={!edit ? `${path}` : combinedUrl}>
            Internal Users
          </NavLink>
        </Menu.Item>
        :
        <Menu.Item key="home"
          icon={
            <NavLink className="menuItem-iocn" to={!edit ? `${path}` : combinedUrl} onClick={() => edit && handleNavigationClick(`${path}`)}>
              <HomeIcon />
            </NavLink>
          }>
          <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}`)} to={!edit ? `${path}` : combinedUrl}>
            Home
          </NavLink>
        </Menu.Item>}

      {/* {canCreate(permissionMenu, "GrowSquare") &&
        <Menu.Item key="growSquare"
          icon={
            <NavLink className="menuItem-iocn" to={!edit ? `${path}/growSquare` : combinedUrl} onClick={() => edit && handleNavigationClick(`${path}/growSquare`)}>
              <GrowSIcon />
            </NavLink>
          }>
          <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}/growSquare`)} to={!edit ? `${path}/growSquare` : combinedUrl}>
            GrowSquare
          </NavLink>
        </Menu.Item>
      } */}
      <Menu.Item key="subscription"
        icon={
          <NavLink className="menuItem-iocn" to={!edit ? `${path}/subscription` : combinedUrl} onClick={() => edit && handleNavigationClick(`${path}/subscription`)}>
            <GrowSIcon />
          </NavLink>
        }>
        <NavLink onClick={() => !edit ? toggleCollapsed() : handleNavigationClick(`${path}/subscription`)} to={!edit ? `${path}/subscription` : combinedUrl}>
          Subscription
        </NavLink>
      </Menu.Item>
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={{ url: linkUrl, type: "Normal" }} />}
    </Menu >
  );
}

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
